import axios from 'axios'


export async function getCountryExternalApi() {
    return await axios
        .get(process.env.VUE_APP_RESTCOUNTRIES_API + 'all?fields=name,cca2,cca3,idd');
}
